// loadScenario — single action that atomically loads a new scenario into the simulation.
//
// All relevant slices respond via extraReducers so the entire store updates
// in one synchronous dispatch. The walker saga watches for this action to
// start playback automatically.

import { createAction } from "@reduxjs/toolkit";
import type { SimulationSeed } from "../../types/index.ts";

export interface LoadScenarioPayload {
  seed: SimulationSeed;
}

export const loadScenario = createAction<LoadScenarioPayload>("scenario/load");
